
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningSnowShowersNightColour as ObiLightningSnowShowersNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-snow-showers-night-colour.js';
 
 
 

 
 export const ObiLightningSnowShowersNightColour = createComponent({
   react: React,
   tagName: 'obi-lightning-snow-showers-night-colour',
   elementClass: ObiLightningSnowShowersNightColourElement,
   events: {
     
   }
  });
 
 